import React from "react"
import { Helmet } from "react-helmet-async"
import { useTranslation } from "react-i18next"

import { getLanguage } from "services/i18n"

import LogoBC from "assets/images/BicyCode-logoBleu.jpg"
import { useOperator } from "hooks"
import { BICYCODE_ID } from "operators/bicycode/config"
import { DECATHLON_ID } from "operators/decathlon/config"
import { MOUSTACHE_ID } from "operators/moustache/config"
import { MFC_ID } from "operators/mfc/config"

type SeoProps = {
	title?: string
	description?: string
}

export const Seo: React.FC<SeoProps> = ({ title, description }) => {
	const { t } = useTranslation()
	const { currentOperator } = useOperator()

	const metaTitle =
		title ||
		t("default_title", {
			ns: "seo",
			operator: currentOperator.name,
		})
	const metaDescription =
		description ||
		t("default_description", {
			ns: "seo",
			operator: currentOperator.name,
		})
	const metaImage = LogoBC
	const metaLang = getLanguage() || "fr"

	const favIcon = () => {
		switch (currentOperator.id) {
			case BICYCODE_ID:
				return "bc-favicon.png"
			case DECATHLON_ID:
				return "dk-favicon.png"
			case MOUSTACHE_ID:
				return "mc-favicon.png"
			case MFC_ID:
				return "mfc-favicon.ico"
		}
	}

	const mainUrl =
		process.env.REACT_APP_MODE === "production"
			? `${window.location.origin}`
			: `${process.env.PUBLIC_URL}`

	return (
		<Helmet>
			<html lang={metaLang} />
			<title>{metaTitle}</title>
			<link id="favicon" rel="icon" href={`${mainUrl}/${favIcon()}`} />
			<meta name="description" content={metaDescription} />

			<meta property="og:title" content={metaTitle} />
			<meta property="og:site_name" content={currentOperator.name} />
			<meta property="og:description" content={metaDescription} />
			<meta property="og:type" content="website" />
			<meta property="og:image" content={metaImage} />

			<meta name="twitter:title" content={metaTitle} />
			<meta name="twitter:image" content={metaImage} />
			<meta name="twitter:card" content="summary" />
			<meta name="twitter:description" content={metaDescription} />
		</Helmet>
	)
}
